
<section #checkpoint [class.animate]="animate">
    <h2 class="for-sreader">Realização todo</h2>
    <img class="line" src="assets/images/fachadas.jpg" width="2006px" height="286px" alt="todo">
    <img class="line mobile" src="assets/images/fachadas-mobile.jpg" width="2006px" height="286px" alt="todo">

    <div class="container d-flex align-top">
        <div class="half">
            <h3 class="f-upper">Dona Empreendimentos</h3>
            <div class="text f-light" [innerHTML]="content[language].companies.dona"></div>
            <br><br>
            <h3 class="f-upper">Gráfico Incorporadora</h3>
            <div class="text f-light" [innerHTML]="content[language].companies.grafico"></div>
        </div>

        <div class="half">
            <h3 class="f-upper">Leão Engenharia</h3>
            <div class="text f-light" [innerHTML]="content[language].companies.leao"></div>
        </div>
    </div>
</section>